import 
{
    experienceIcon1,
    growthIcon1,
    sessionsIcon1,
    timeIcon1, 
} from "../assets/img/imgAssets"

const aboutJourneyData = [
    { icon: timeIcon1, head: '6+', desc: 'Yrs' },
    { icon: growthIcon1, head: '400+', desc: 'Journeys' },
    { icon: sessionsIcon1, head: '6000+', desc: 'Sessions' },
    { icon: experienceIcon1, head: '5/5', desc: 'Experience' },

]

export {
    aboutJourneyData
}